import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Calendar, ArrowRight } from 'lucide-react';
import {
  blogPosts,
  getReadingTime,
  getCategoryLabel,
  formatPostDate,
} from '../data/blogPosts';

const BlogPreview = () => {
  const posts = [...blogPosts].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 3);

  if (posts.length === 0) return null;

  return (
    <section className="py-16 bg-white" data-testid="home-blog-section">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 gap-4">
          <div>
            <p className="text-orange-500 font-semibold uppercase tracking-wider text-sm mb-2">
              Blog GENSOL
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Artículos más populares
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="home-blog-view-all"
            data-analytics-click="home-blog-view-all"
            className="inline-flex items-center gap-2 text-orange-500 hover:text-orange-600 font-semibold transition-colors"
          >
            Ver todos los artículos <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article
              key={post.slug}
              data-testid={`home-blog-card-${post.slug}`}
              className="bg-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 flex flex-col"
            >
              <Link to={`/blog/${post.slug}`} className="block overflow-hidden">
                <img
                  src={post.image}
                  alt={post.imageAlt}
                  loading="lazy"
                  width="600"
                  height="340"
                  className="w-full h-52 object-cover hover:scale-105 transition-transform duration-500"
                />
              </Link>
              <div className="p-6 flex flex-col flex-1">
                <span className="inline-block self-start text-xs font-semibold uppercase tracking-wide text-orange-600 bg-orange-100 px-3 py-1 rounded-full mb-3">
                  {getCategoryLabel(post.category)}
                </span>
                <h3 className="text-lg font-bold text-gray-900 leading-snug mb-2">
                  <Link
                    to={`/blog/${post.slug}`}
                    data-testid={`home-blog-link-${post.slug}`}
                    className="hover:text-orange-500 transition-colors"
                  >
                    {post.title}
                  </Link>
                </h3>
                <p className="text-gray-600 text-sm mb-4 flex-1">{post.excerpt}</p>
                <div className="flex items-center gap-4 text-xs text-gray-500 border-t border-gray-200 pt-4">
                  <span className="flex items-center gap-1">
                    <Calendar className="w-3.5 h-3.5 text-orange-500" />
                    <time dateTime={post.date}>{formatPostDate(post.date)}</time>
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock className="w-3.5 h-3.5 text-orange-500" />
                    {getReadingTime(post)} min de lectura
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
